import config from "config";

const GetRouteByClass = (className: string, id: string) => {
    let route = config.S3Region + ".amazonaws.com/" + config.S3Bucket + "/" + config.site + "/" + config.deployment + "/" + className.toLowerCase() + "/" + id + ".json";
    return route;
}

const GetNavbarRoute = () => {
    let route = config.S3Region + ".amazonaws.com/" + config.S3Bucket + "/" + config.site + "/" + config.deployment + "/navbar/navbar.json";
    return route;
}



export default { GetNavbarRoute, GetRouteByClass };